import { 
  IonButton,
  IonText
} from '@ionic/react';
import Fade from 'react-reveal/Fade';

import './IntroSection.css'

const IntroSection = (userDevice) => {
return(
    <div className="prelogin-intro-background"
    style={{
        
        backgroundImage: `url(${process.env.PUBLIC_URL}/background/${userDevice==='mobile'?'prelogin_intro_mobile.png': 'prelogin_intro.png'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: userDevice ==='mobile' ? '370px' : '587px'
    }}
    >
        <div 
        style={{
            display:'flex',
            flexDirection:'column',
            justifyContent:'center',
            alignItems:'flex-start',
            padding:'20px',
            maxWidth: '1200px',
            width: '100%',
            margin: '0 auto',
        }}
        >
        <Fade up>
            <div 
            style={{
                flexDirection: 'column',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                paddingBottom: '25px',
            }}
            >
                <IonText 
                className="font-pink-1 font-semibold font-baloo"
                style={{
                    lineHeight: userDevice==='mobile'? '1.75rem':'4rem',
                    letter: '-0.48px',
                    fontSize: userDevice==='mobile'? '1.85rem':'4rem',
                }}
                >Delivery is easy<br/>with RydeSEND</IonText>
                <IonText 
                className="font-m font-pink-1 font-baloo"
                style={{
                    paddingBlock: userDevice ==='mobile'? '1px' : '30px',
                    paddingBottom: userDevice ==='mobile'? '1px' : '35px',
                    maxWidth: '60%',
                    letter: '-0.48px',
                    lineHeight: userDevice ==='mobile'? '1.25rem':'1.5rem',
                    fontSize: userDevice ==='mobile'? '0.1rem':'4rem',
                    size: '0.1rem'
                }}
                >
                    {
                        userDevice ==='mobile' &&  <p style={{fontSize: '0.75rem'}}>We are an on-demand point to point delivery service for both business and <br/>personal delivery needs.</p>
                    }
                    {
                        userDevice !=='mobile' && 'We are an on-demand point to point delivery service for both business and personal delivery needs.'
                    }
                   
                </IonText>
                <IonButton 
                className="prelogin-button ion-no-margin" 
                style={{
                    minWidth:"200px"
                }}
                
                // onClick={() => window.open('https://ryde.app.link/rydesend_dl')}>
                href="/login"
                >
                    <IonText 
                    className="font-xs"
                    style={{
                        paddingInline: '30px'
                    }}
                    >
                        Book RydeSEND Now
                    </IonText>
                </IonButton>
            </div>
        </Fade>
        </div>
    </div>
)
}

export default IntroSection;